const meta = {
  default: {
    pageTitle: 'IhreApotheken.de',
    image: 'ia-share.jpg',
    imageWidth: '512',
    imageHeight: '512',
    canonical: '',
  },
  apofinder: {
    pageTitle: 'Apotheken & Notdienste in der Nähe finden {\'|\'} IhreApotheken.de',
    pageDescription: 'Finden Sie auf IhreApotheken.de tausende Apotheken in Deutschland sowie Apotheken mit Notdienst. Online Produkte in Ihrer Apotheke bestellen, abholen oder per Botendienst liefern lassen.',
    canonical: 'https://ihreapotheken.de/apofinder',
    robots: 'index, follow',
  },
  apofinderLandingPage: {
    pageTitle: 'Finden Sie eine Apotheke {\'|\'} Jetzt Apotheke wählen und bestellen {\'|\'} IhreApotheken.de  - Ihre Apotheken',
    pageDescription: 'Finden Sie auf IhreApotheken.de tausende Apotheken in Deutschland sowie Apotheken mit Notdienst.',
    pageTitleWithCity: 'Finden Sie eine Apotheke in {city} {\'|\'} Jetzt Apotheke wählen und bestellen {\'|\'} IhreApotheken.de  - Ihre Apotheken',
    pageDescriptionWithCity: 'Apotheke in meiner Nähe: Jetzt über IhreApotheken.de die passende Apotheke aus über 8.000 Apotheken deutschlandweit auswählen und sofort bestellen. Apotheken in {city}.',
    robots: 'index, follow',
  },
  productListing: {
    pageTitle: 'Medikamente, Beauty- und Pflegeprodukte bestellen {\'|\'} Ihrer Apotheke vor Ort - iA.de',
    pageTitlePharmacy: '{pharmacy} - Medikamente, Beauty- und Pflegeprodukte bestellen - iA.de',
    pageDescription: 'Finden und reservieren Sie Produkte in Ihrer Apotheke vor Ort. Sie können sich Arzneimittel auch direkt liefern lassen!',
    pageDescriptionPharmacy: 'Finden und reservieren Sie Produkte in Apotheke {pharmacy}. Sie können sich Arzneimittel auch direkt liefern lassen!',
    canonical: 'https://ihreapotheken.de/produkte',
    canonicalCategories: 'https://ihreapotheken.de/produkte/kategorie/{categoryName}',
    canonicalManufacturers: 'https://ihreapotheken.de/produkte/hersteller/{manufacturerId}',
    robots: 'noindex, nofollow',
    robotsPharmacy: 'noindex, nofollow',
  },
  productSearch: {
    pageTitle: '{searchTerm} auf iA.de',
    pageDescription: '{searchTerm} bei iA.de entdecken - Apotheken auswählen und {searchTerm} vorbestellen - einfach, schnell und sicher',
    pageDescriptionPharmacy: '{searchTerm} bei iA.de entdecken - Apotheken auswählen und {searchTerm} vorbestellen - einfach, schnell und sicher',
    canonical: 'https://ihreapotheken.de/suche?search={searchTerm}',
    robots: 'noindex, nofollow',
  },
  productDetail: {
    pageTitle: '{productName} {\'|\'} {packaging} - IhreApotheken.de',
    pageDescriptionCategoryAndCharacteristic: '{characteristics}: Zum Einsatz im Bereich {category}. Lieferung meist noch am selben Tag.',
    pageDescriptionCategory: '{productName} ist ein Apothekenprodukt aus dem Bereich {category}. Lieferung meist noch am selben Tag.',
    pageDescriptionPharmacy: 'Bestellen Sie {productName} bei {pharmacy}. Lieferung meist noch am selben Tag.',
    pageDescription: 'Bestellen Sie {productName} bei IhreApotheken.de. Lieferung meist noch am selben Tag.',
    canonical: 'https://ihreapotheken.de/produkt/{productName}',
    robots: 'noindex, nofollow',
    robotsPharmacy: 'noindex, nofollow',
  },
  prescriptionUpload: {
    pageTitle: 'Lösen Sie Ihr (E-)Rezept ein {\'|\'} IhreApotheken.de',
    pageTitlePharmacy: 'Rezepte & E-Rezepte hochladen und einlösen {\'|\'} Ihre Apotheken {\'|\'} IhreApotheken.de',
    pageDescription: 'Lösen Sie Ihre Rezepte einfach online ein und erhalten Sie die Produkte innerhalb kürzester Zeit in Ihrer Apotheke vor Ort oder per Botendienst.',
    pageDescriptionPharmacy: 'Laden Sie Ihre Rezepte und E-Rezepte hoch und lösen Sie sie direkt bei Ihrer Apotheke vor Ort ein. Lieferung meist noch am selben Tag.',
    canonical: 'https://ihreapotheken.de/rezept-upload',
    robots: 'noindex, nofollow',
    robotsPharmacy: 'noindex, nofollow',
  },
  homepage: {
    pageTitle: 'IhreApotheken - Online bei Ihrer Apotheke vor Ort bestellen {\'|\'} iA.de',
    pageDescription: 'Lieblings-Apotheke auswählen. Rezepte einlösen und Medikamente online bestellen. Per Botendienst bringen lassen oder selbst abholen.',
    canonical: 'https://ihreapotheken.de/',
    robots: 'noindex, nofollow',
  },
  pharmacyStartpage: {
    pageTitle: '{pharmacyName} {\'|\'} IhreApotheken.de {\'|\'} zum Apotheken-Profil auf iA.de',
    pageDescription: '{pharmacyName} {\'|\'} IhreApotheken.de {\'|\'} zum Apotheken-Profil auf iA.de. {pharmacyAddress} {pharmacyPlz} {pharmacyCity} auf IhreApotheken.de {\'|\'} bei iA.de online Rezepte einlösen und Medikamente vorbestellen',
    canonical: 'https://ihreapotheken.de/apotheke/{pharmacySlug}',
    robots: 'noindex, nofollow',
  },
}

export default meta
